<template>
  <div class="voteList" ref="topBanner" id='voteList'>
    <div class="fixed">
      <div class="top_header top_sm">
        <div class="top_normal">
          <!-- <van-icon name="arrow-left" @click="returnGo"/> -->
          <img
            src="@/assets/img/back_.png"
            alt=""
            class="back_"
            @click="returnGo"
          />
        </div>
      </div>
    </div>
    <div class="main_img">
      <img src="@/assets/img/vote/vote.jpg" alt="" />
    </div>
    <div class="main_content">
      <div class="flex_1">
        <div>
          <p>{{ tpCount }}</p>
          <p>参赛项目</p>
        </div>
        <div>
          <p>{{ voteCount }}</p>
          <p>累计投票</p>
        </div>
      </div>
      <div class="word_1">
        <div class="word_title">活动规则</div>
        <div class="word_content">
          1.投票时间：2021年12月20日0时-12月31日24时；</br>
          2.投票结果公示时间：2022年元月5日；</br>
          3.网络投票阶段，每个用户每日最多可投10票；</br>
          4.恶意刷票者一经发现，取消所投票数并关闭投票通道；</br>
          5.本活动最终解释权归徐州市房地产信息网所有
        </div>
      </div>
      <div class="input_1">
        <div class="search-content">
          <input type="text" placeholder="请输入名称" v-model="title" />
        </div>
        <div class="search-btn" @click="searchName">搜索</div>
      </div>
      <div class="list_1">
        <div class="list_flex">
          <div :class="tab == 0 ? 'active' : ''" @click="tab = 0">参赛项目</div>
          <div :class="tab == 1 ? 'active' : ''" @click="tab = 1">评选榜单</div>
        </div>
        <div class="list_arr" v-if="tab == 0">
          <!-- <div class="list_data"> -->
          <div class="line" v-for="(item, index) in list" :key="item.id">
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="ranking">
              <p>{{ item.sort }}号</p>
              <p>{{ item.voteNum }}票</p>
            </div>
            <div class="btn">
              <p @click="confirmationVote(item.id)">
                投票
                <!-- <i class="flash-across"></i> -->
              </p>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div class="list_sort" v-else>
          <div class="list_every" v-for="(item, index) in list2" :key="item.id">
            <span>
              {{ index + 1 }}名
              <i></i>
            </span>
            <span>{{ item.sort }}号</span>
            <span>{{ item.title }}</span>
            <span>{{ item.voteNum }}票</span>
          </div>
        </div>
      </div>
    </div>
    <img
      class="to_top"
      @click="toTop"
      src="@/assets/img/toTop.png"
      alt=""
      v-show="toTopShow"
    />
  </div>
</template>
<script>
export default {
  inject: ["reload", "judgeApp"],
  data() {
    return {
      title: "",
      tpCount: "",
      voteCount: "",
      appToken: "",
      tab: 0,
      isApp: this.$route.query.isApp || false,
      // isWx: this.$route.query.isWx || false,
      // wxAppToken: this.$route.query.user || false,
      type: this.$route.query.type || "",
      toTopShow: false,
      list: [],
      list2: [],
    };
  },
  created() {
    // this.assignmentTooken();
    this.initData();
    this.$share(
      "守望来者·谋远前行 徐州市房地产信息网 2021中国·徐州房地产行业颁奖盛典",
      "行业盛典 等你投票",
      "https://www.xzhouse.com.cn/house/xzh_static/sVideo/vote.jpg"
    );
  },
  mounted() {
    window.onscroll = () => {
      var scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 400) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    };
    this.initData2();
  },
  components: {},
  methods: {
    panduan(itemID) {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var token = "";
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break;
          }
        }
        if (token) {
          this.appToken = token;
          this.showDialog(itemID);
        } else {
          if (this.judgeApp() == "isIOS") {
            window.webkit.messageHandlers.checkLogin.postMessage(null);
          } else {
            window.android.checkLogin();
          }
        }
      } else {
        // if (this.isWx || this.isWx == "true") {
        //   if (!this.wxAppToken) {
        //     uni.navigateTo({
        //       url: `/pages/index/login`,
        //     });
        //   } else {
        //     this.wxAppToken = this.$route.query.user;
        //   }
        // } else {
        this.isLogin(itemID);
        // }
      }
    },
    isLogin(itemID) {
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.appToken = JSON.parse(
              localStorage.getItem("tokenObj")
            ).appToken;
            this.showDialog(itemID);
          }
        } else {
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    returnGo() {
      this.$router.go(-1);
    },
    searchName() {
      this.initData();
      this.initData2();
    },
    showDialog(itemID) {
      this.$dialog
        .confirm({
          confirmButtonColor: "#2F72F5",
          title: "提示",
          message: "您确定投票嘛？1日内仅允许投票十次，请谨慎操作",
        })
        .then(() => {
          const formData = new FormData();
          formData.append("appToken", this.appToken);
          formData.append("voteId", itemID);
          this.$http({
            url: "house/tpRecord/doVote.do",
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: formData,
          }).then((res) => {
            if (res.success) {
              this.$toast("投票成功");
              this.$nextTick(() => {
                this.reload();
              }, 200);
            } else {
              this.$toast(res.msg);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    confirmationVote(itemID) {
      this.panduan(itemID);
    },
    initData() {
      const formData = new FormData();
      formData.append("type", this.type);
      formData.append("sortType", "1");
      formData.append("title", this.title);
      this.$http({
        url: "house/tpRecord/getListByType.do",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then((res) => {
        this.tpCount = res.attributes.tpCount;
        this.voteCount = res.attributes.voteCount;
        this.list = res.obj;
      });
    },
    initData2() {
      const formData = new FormData();
      formData.append("type", this.type);
      formData.append("sortType", "2");
      formData.append("title", this.title);
      this.$http({
        url: "house/tpRecord/getListByType.do",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then((res) => {
        this.list2 = res.obj;
      });
    },
    toTop() {
      this.$refs.topBanner.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    jump(item) {
      let _this = this;
      this.$nextTick(() => {
        let company = _this.$el.querySelector(item);
        document.documentElement.scrollTop = company.offsetTop; //苹果滚动
        document.body.scrollTop = company.offsetTop; //安卓滚动
      });
    },
  },
};
</script>
<style lang="less" scoped>
@media only screen and (min-width: 980px) {
  #voteList {
    max-width: 1100px;
    margin: 0 auto;
    .fixed {
      display: none;
    }
    .main_img {
      img {
        // height: 6.5rem;
      }
    }
    .main_content {
      .list_1 {
        .list_flex {
          div {
            height: 0.5rem;
            line-height: 0.5rem;
            font-size: 0.2rem;
          }
        }
        .list_arr {
          .line {
            font-size: 0.2rem;
            width: 23%;
            .photo {
              img {
                height: 1.8rem;
              }
            }
            .btn {
              p {
                font-size: 0.2rem;
                padding: 0.05rem;
              }
            }
          }
        }
      }
      .flex_1 {
        & > div {
          p {
            font-size: 0.2rem;
          }
        }
      }

      .word_1 {
        .word_content {
          font-size: 0.2rem;
        }
      }
    }
  }
}
// @keyframes changeImg {
//   from {
//     left: -10%;
//   }
//   100% {
//     left: 100%;
//   }
// }
.main_img {
  width: 100%;
  img {
    width: 100%;
    vertical-align: bottom;
  }
}
.main_content {
  min-height: 100vh;
  padding: 0.3rem 0.2rem;
  background: #121211;
  .flex_1 {
    padding: 0.2rem 0;
    background: #fff;
    display: flex;
    border-radius: 5px;
    & > div {
      flex: 1;
      p {
        font-size: 0.3rem;
        text-align: center;
      }
    }
  }
  .word_1 {
    margin-top: 0.4rem;
    background: #fff;
    border-radius: 5px;
    .word_title {
      color: #fff;
      font-size: 0.3rem;
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      background: #5c5c78;
      font-weight: 900;
    }
    .word_content {
      font-size: 0.26rem;
      line-height: 0.4rem;
      padding: 0.2rem;
    }
  }
  .input_1 {
    display: flex;
    justify-content: space-around;
    margin-top: 0.4rem;
    .search-content {
      font-size: 24px;
      position: relative;
      width: 70%;
      border: 2px solid #ffffff;
      background-color: #fff;
      text-align: center;
      vertical-align: middle;
      height: 0.7rem;
      border-radius: 6px;
      input {
        background: none;
        border: none;
        width: 86%;
        font-size: 0.3rem;
        outline: none;
        color: #666;
        padding-left: 14%;
        height: 0.7rem;
      }
    }
    .search-btn {
      background: #5c5c78;
      width: 25%;
      text-align: center;
      height: 0.7rem;
      line-height: 0.7rem;
      font-size: 0.3rem;
      color: #fff;
      border: 2px solid #5c5c78;
      border-radius: 5px;
      overflow: hidden;
    }
  }
  .list_1 {
    margin-top: 0.4rem;
    .list_flex {
      display: flex;
      div {
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        flex: 1;
        background: #fff;
        font-size: 0.3rem;
      }
      .active {
        background: #5c5c78;
        color: #fff;
      }
    }
    .list_arr {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .line {
        margin-top: 0.4rem;
        width: 48%;
        background: #ccc;
        padding: 0.2rem;
        font-size: 0.3rem;
        box-sizing: border-box;
        .photo {
          width: 100%;
          img {
            height: 2.3rem;
            width: 100%;
          }
        }
        .name {
          padding: 0.1rem 0;
          text-align: center;
          color: #000;
        }
        .ranking {
          // padding: 0.1rem 0;
          display: flex;
          justify-content: space-around;
        }
        .btn {
          box-sizing: border-box;
          padding: 0.1rem 0.2rem;
          p {
            position: relative;
            text-indent: 3px;
            letter-spacing: 3px;
            background: #000;
            color: #fff;
            font-weight: 800;
            font-size: 0.3rem;
            text-align: center;
            padding: 0.1rem;
            border-radius: 5px;

            .flash-across {
              position: absolute;
              animation: changeImg 3s ease 0;
              top: 0;
              width: 30%;
              height: 100%;
              content: "";
              background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0,
                rgba(255, 255, 255, 0.4) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              transform: skewX(-45deg);
              animation-iteration-count: infinite;
            }
          }
        }
      }
    }
    .list_sort {
      margin-top: 0.4rem;
      background: #fff;
      border-radius: 5px;
      .list_every {
        display: flex;
        padding: 0.2rem 0.3rem;
        font-size: 0.3rem;
        span:first-child {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 10%;
        }
        span:nth-child(2) {
          width: 10%;
        }
        span:nth-child(3) {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 60%;
        }
        span:last-child {
          width: 20%;
          text-align: right;
        }
      }
    }
  }
}
.to_top {
  width: 0.84rem;
  height: 0.84rem;
  position: fixed;
  z-index: 8;
  right: 0.15rem;
  bottom: 1.5rem;
}
.fixed {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  width: 50%;
  z-index: 9909;
  background-color: transparent;
  .top_header {
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 100%;
    margin: 0 auto;
    .back_ {
      width: 0.38rem;
      height: 0.38rem;
    }
    .top_normal {
      align-items: center;
      display: flex;
      height: 100%;
    }
  }
}
</style>